import { render, staticRenderFns } from "./FavoriteDesignerCard.vue?vue&type=template&id=2f9b03ff&"
import script from "./FavoriteDesignerCard.vue?vue&type=script&lang=js&"
export * from "./FavoriteDesignerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports